import { MapTheme } from './types';
import { ChevronDown } from 'lucide-react';
import { useState } from 'react';

type ThemeSelectorProps = {
  value: MapTheme;
  onChange: (theme: MapTheme) => void;
};

const themes: { value: MapTheme; label: string }[] = [
  { value: 'satellite', label: 'Satellite' },
  { value: 'minimal', label: 'Minimal' },
  { value: 'streets', label: 'Streets' }
];

export default function ThemeSelector({ value, onChange }: ThemeSelectorProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="bg-white/80 backdrop-blur-sm rounded-lg shadow-sm px-3 py-2 flex items-center gap-2 text-sm w-full"
      >
        <span className="text-gray-700">{themes.find(t => t.value === value)?.label}</span>
        <ChevronDown className="h-4 w-4 text-gray-500" />
      </button>

      {isOpen && (
        <div className="absolute bottom-full mb-1 w-full bg-white rounded-lg shadow-lg py-1">
          {themes.map(theme => (
            <button
              key={theme.value}
              onClick={() => {
                onChange(theme.value);
                setIsOpen(false);
              }}
              className={`w-full px-3 py-2 text-sm text-left transition-colors ${
                value === theme.value
                  ? 'bg-gray-100 text-[#005E6E] font-medium'
                  : 'text-gray-700 hover:bg-gray-50'
              }`}
            >
              {theme.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}